import { useState, useEffect } from "react";
import { signInAnonymously, onAuthStateChanged } from "firebase/auth";
import { auth } from "../services/firebase";
import { syncPendingFCMTokens } from "../services/notificationService";

export function useAuth() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
      setLoading(false);

      // Sync any pending FCM tokens when user becomes authenticated
      if (user?.uid) {
        syncPendingFCMTokens().catch((error) => {
          console.error("Failed to sync pending FCM tokens:", error);
        });
      }
    });

    return unsubscribe;
  }, []);

  useEffect(() => {
    if (!loading && !user) {
      const isAdminRoute =
        typeof window !== "undefined" &&
        window.location?.hash?.includes("/admin");

      if (isAdminRoute) {
        return;
      }

      // Sign in anonymously if not authenticated
      signInAnonymously(auth).catch((error) => {
        console.error("Anonymous sign-in failed:", error);
      });
    }
  }, [loading, user]);

  return { user, loading };
}
